import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { INVESTMENT_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormDefaults";
import type { InvestmentFormInput } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";

export const mapPortfolioToInvestmentForm = (
	portfolio: PortfolioDetailResponseDTO,
): InvestmentFormInput => {
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		productCategoryId:
			portfolio.productCategoryId ?? DEFAULTS.productCategoryId,
		maturityLengthMonths:
			portfolio.maturityLengthMonths ?? DEFAULTS.maturityLengthMonths,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		note: portfolio.note ?? DEFAULTS.note,
	};
};
